import { render, staticRenderFns } from "./level1.vue?vue&type=template&id=0c425242&"
import script from "./level1.vue?vue&type=script&lang=ts&"
export * from "./level1.vue?vue&type=script&lang=ts&"
import style0 from "./level1.vue?vue&type=style&index=0&id=0c425242&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports